import VariationCard from "./VariationCard";
import styles from "./variations.module.css";

const Variations = ({ variations, hotspots, getPrice, defaultVariationId }) => {
  return (
    <div className={styles.variationsContainer}>
      {variations?.map((variation) => (
        <VariationCard
          key={variation.id}
          variation={variation}
          hotspots={hotspots[variation.id]}
          getPrice={getPrice}
          defaultVariationId={defaultVariationId}
        />
      ))}
    </div>
  );
};

export default Variations;
